const DEFAULT_METADATA = {};
const DEFAULT_REGION = '';
const DEFAULT_KEY = '';
const DEFAULT_VALUES = {};

const Metadata = (metadata = DEFAULT_METADATA, region = DEFAULT_REGION) => {
  const findMetadataByKey = (key = DEFAULT_KEY) => {
    const options = metadata?.[key];

    try {
      if (!options) throw new Error('No metadata found');

      const parsedOptions = JSON.parse(options);
      const metadataValues = parsedOptions?.[region] || parsedOptions?.default;

      if (!metadataValues) throw new Error('No metadata values found');
      return metadataValues;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.debug('Error parsing metadata: ', error);
      return DEFAULT_VALUES;
    }
  };

  return {
    findMetadataByKey,
  };
};

export default Metadata;
